import { render, staticRenderFns } from "./tiaolionline.vue?vue&type=template&id=50ff0d56&scoped=true&"
import script from "./tiaolionline.vue?vue&type=script&lang=js&"
export * from "./tiaolionline.vue?vue&type=script&lang=js&"
import style0 from "./tiaolionline.vue?vue&type=style&index=0&id=50ff0d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ff0d56",
  null
  
)

export default component.exports